"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storageModule = void 0;
const tslib_1 = require("tslib");
const storage_1 = require("./storage");
const provider_1 = require("./provider");
const file_1 = require("./file");
const runtime_1 = require("./runtime");
(0, tslib_1.__exportStar)(require("./storage"), exports);
(0, tslib_1.__exportStar)(require("./provider"), exports);
exports.storageModule = {
    name: 'storage',
    components: { providers: provider_1.providers, Storage: storage_1.Storage, LCFile: file_1.LCFile },
    onLoad: (runtime) => {
        (0, runtime_1.setSDKRuntime)(runtime);
        const { App } = runtime.modules.core.components;
        App.prototype.storage = function () {
            return new storage_1.Storage(this);
        };
    },
};
